import React from 'react';
import './Footer.css'

import Logo from '../../Assets/Logo.svg'

const Footer = () => {
    return ( 
        <footer>
            <div className='FCol'>
                <img src={Logo} alt="" />

                <p className='FSub'>
                    Eventick is a global self-service ticketing platform for live experiences that allows anyone to create, share, find and attend events that fuel their passions and enrich their lives.
                </p>
            </div>

            <div className='FooterNavs'>
                <div className='FCol'>
                    <p className='ColTitle'>Plan Events</p>

                    <div className='FNavBtns'>
                        <p className='FNavBtn'>
                            Create and Set Up
                        </p>
                        <p className='FNavBtn'>
                            Sell Tickets
                        </p>
                        <p className='FNavBtn'>
                            Online RSVP 
                        </p>
                        <p className='FNavBtn'>
                            Online Events
                        </p>
                    </div>
                </div>

                <div className='FCol'>
                    <p className='ColTitle'>Eventick</p>

                    <div className='FNavBtns'>
                        <p className='FNavBtn'>
                            About Us
                        </p>
                        <p className='FNavBtn'>
                            Press
                        </p>
                        <p className='FNavBtn'>
                            Contact Us 
                        </p>
                        <p className='FNavBtn'>
                            Help Center
                        </p>
                        <p className='FNavBtn'>
                            How it Works
                        </p>
                        <p className='FNavBtn'>
                            Privacy
                        </p>
                        <p className='FNavBtn'>
                            Terms
                        </p>
                    </div>
                </div>
            </div>
        </footer>
     );
}
 
export default Footer;